/* eslint-disable */
import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { ArrowRightIcon } from "@heroicons/react/20/solid";

export function PaymentandRegistrationFrom({ updateFields }) {
  return (
    <div className="flex justify-center items-center ">
      <div className="text-center rounded-lg w-96 ">
        <button
          className={`mt-3 bg-white-500 hover:border-b-4 hover:border-green-500 hover:text-black text-black font-bold py-2 px-4 border border-black`}
          onClick={() => alert('Payment and Registration')} // Add onClick event
        >
          Payment and Registration{' '}
          <span className="text-green-500">✓</span>
        </button>
        <br></br>
        <div className="mt-4 flex flex-col sm:flex-row justify-center">
          <button
            type="button"
            className="mt-4 sm:mt-0 rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 flex items-center"
            style={{ minWidth: '200px' }} // Set minimum width to ensure equal width
          >
            <svg className="h-8 w-8 text-black-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
            </svg>
            Credit / Debit card
          </button>
          <button
            type="button"
            className="mt-4 sm:mt-0 ml-0 sm:ml-4 rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 flex items-center"
            style={{ minWidth: '200px' }} // Set minimum width to ensure equal width
          >
            <svg className="h-8 w-8 text-black-500" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17.788 5.108A9 9 0 1021 12h-8" />
            </svg>
            Google pay
          </button>
        </div>
        
        <h1 className="mt-4">Note for developer</h1>
        <p className="text-green-500 font-bold text-justify">
          PAYMENT DETAILS HERE BASED ON SELECTED OPTION COMMONLY USED COMPONENTS, NOTHING SPECIAL HERE WILL PROBABLY NEED
          SCROLL ON THE PAGE IF THERE ARE BILLING DETAILS AND ADDRESS THAT NEEDS TO BE INPUT
        </p>
        
        <div className="flex justify-center mt-5 mb-5 gap-5">
          <button
            type="button"
            className="rounded-md bg-red-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 flex items-center justify-center"
          >
            Cancel
            <span className="ml-1">
              <XMarkIcon className="h-5 w-5 text-white font-bold" aria-hidden="true" />
            </span>
          </button>
          <button
            type="button"
            className="rounded-md bg-green-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 flex items-center justify-center"
          >
            Complete
            <span className="ml-1 text-white-500"> ✓</span>
          </button>
        </div>
      </div>
    </div>
  );
}
